import * as R from 'ramda'
import {
  getAllAncestors,
  injectLinkTo,
  isInAllProductsScope,
  isTypeSale
} from 'domain/resources'
import { Resource } from 'types/typescript'
import { CreateBreadcrumb } from './scope.types'

export const createBreadcrumb: CreateBreadcrumb = (
  currentResource,
  saleHasOnlyOneUniverse,
  scope,
  sale,
  allResources,
  opeCode,
  withAllProducts
) => {
  const injectLinkToScope = injectLinkTo(scope as Resource, opeCode, allResources)
  const saleWithLink = injectLinkToScope(sale)
  const currentResourceWithLink = injectLinkToScope(currentResource)

  if (isTypeSale(currentResource)) {
    return [saleWithLink]
  }
  if (saleHasOnlyOneUniverse) {
    return [
      saleWithLink,
      currentResourceWithLink
    ]
  }
  if (withAllProducts && isInAllProductsScope(scope as Resource, currentResource)) {
    return [
      saleWithLink,
      injectLinkToScope(scope as Resource),
      currentResourceWithLink
    ]
  }
  return R.pipe(
    getAllAncestors([currentResource], allResources),
    R.reverse,
    R.map(injectLinkToScope)
  )(currentResource)
}
